export enum WorkTypeEndpoints {
	FetchWorkTypes = '/work-types',
}
